import src from "IMAGE";
export default { src, width: 1920, height: 496, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAK0lEQVR42l3IuREAMAgDQSpATyvqvzcPRB6CC/bKdqbujqRc14DkDgA7fz/M8wY6wRj2xAAAAABJRU5ErkJggg=="};
